import * as React from 'react'
import { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import SettingsIcon from '@mui/icons-material/Settings'

export default function MenuSettings({isAdmin}) {
    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <div>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                sx={{ color: "inherit", minWidth: 0, padding: 1 }}
            >
                <SettingsIcon />
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem component={Link} to="/titles" onClick={handleClose}>Titles </MenuItem>
                {/* {isAdmin && (
                    <MenuItem component={Link} to="/org-unit-path" onClick={handleClose}>Org Unit Paths</MenuItem>
                )} */}
                <MenuItem component={Link} to="/departments/" onClick={handleClose}>Departments</MenuItem>
                <MenuItem component={Link} to="/work-locations/" onClick={handleClose}>Work Locations</MenuItem>
                {isAdmin && (<MenuItem component={Link} to="/people-builder-settings/" onClick={handleClose}>People Builder Setup</MenuItem>)}
                {isAdmin && <MenuItem component={Link} to="/access-type/">Access Manager</MenuItem>}
            </Menu>
        </div>
    );
}